import { createIconComponent } from '../../factory/create-icon-component';
export const PinnedIcon = createIconComponent(
  'PinnedIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.31329 18.7033L8.20921 15.5693"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.069 11.6661L11.3495 19.4736C11.6923 19.8998 12.3152 19.9673 12.7414 19.6244V19.6244C12.9907 19.4239 13.128 19.1158 13.1093 18.7959L12.893 15.0106L15.2305 13.1302L18.1589 14.0536C18.4781 14.1537 18.8259 14.0882 19.0861 13.8789L19.4485 13.5874C19.8786 13.2414 19.9468 12.6115 19.6008 12.1814L13.9597 5.16878C13.6137 4.73867 12.9838 4.6704 12.5537 5.01639L12.1914 5.30785C11.9311 5.5172 11.7919 5.84351 11.822 6.17608L12.0965 9.23432L9.75899 11.1147L6.10801 10.0924C5.79948 10.0056 5.4692 10.0736 5.21986 10.2742V10.2742C4.79365 10.6171 4.72614 11.2399 5.069 11.6661V11.6661Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
